const home = {
  heroTitle: '热门电视剧大全',
  heroSubtitle: '免费高清在线免VIP观看',
  heroDesc: '电视剧全集播放，不缓冲看剧免费在线观看，全集免费电视剧流畅追剧完整版',
  heroCta: '开始追剧',
  hotRecommend: '热门推荐',
  latestUpdate: '最新更新',
  viewAll: '查看全部',
  allCategories: '全部分类',
  featuredTitle: '精选好剧',
  featuredDesc: '全网高分热剧一网打尽，随时随地畅享高清追剧体验',
  statTitles: '海量资源',
  statSeries: '热播剧集',
  statUpdate: '每日更新',
  whyUsTitle: '为什么选择成全影视',
  whyUs1Title: '海量资源',
  whyUs1Desc: '汇聚全球热门电视剧，国产剧、韩剧、美剧、日剧应有尽有',
  whyUs2Title: '高清流畅',
  whyUs2Desc: '支持高清画质播放，不缓冲不卡顿，给您最佳观影体验',
  whyUs3Title: '完全免费',
  whyUs3Desc: '无需VIP会员，所有剧集免费观看，追剧零负担',
  whyUs4Title: '每日更新',
  whyUs4Desc: '紧跟播出进度，第一时间更新最新剧集，不再错过精彩内容',
};

export default home;